var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"search-view"}},[_c('g-contents',{attrs:{"title":_vm.$route.params.title,"data":_vm.$route.params.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }